export default "__VITE_ASSET__adeef8ca__"